import { ReactElement, ReactNode } from 'react';
import styles from './Divider.module.scss';
import classNames from 'classnames/bind';
import { Typography } from '@weareopenr/component-library';

interface IDividerProps {
  title?: string;
  children?: ReactNode;
  action?: ReactElement;
  colour?: 'caviar' | 'liquorice';
}

const cx = classNames.bind(styles);

const Divider = ({ title, children, action, colour = 'liquorice' }: IDividerProps): ReactElement => {
  return (
    <div className={styles.divider} data-testid={`${title}-section-divider`}>
      <div
        className={cx('line', 'left-line', {
          [`line-${colour}`]: colour,
        })}
      />
      {children ?? (
        <Typography size="medium" className={cx('title', { 'title-long': title.length > 40 })}>
          {title}
        </Typography>
      )}
      <div className={cx('right-content')}>
        <div
          className={cx('line', {
            [`line-${colour}`]: colour,
          })}
        />
        {action}
      </div>
    </div>
  );
};

export default Divider;
